import styled from "@emotion/styled";
import { Button } from "@mui/material";


export const BottomBarActionBtn = styled(Button)({
  margin: "16px", borderRadius: "40px", padding: "16px", minWidth: "150px" 
});